var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M14.988 7.996c0 3.868-3.132 7-7 7s-7-3.132-7-7 3.133-7 7-7 7 3.133 7 7m-7 5.6a5.59 5.59 0 0 0 4.343-2.063C11.304 9.802 9.74 8.696 7.988 8.696s-3.315 1.106-4.342 2.838a5.59 5.59 0 0 0 4.342 2.062m2-7.6a2 2 0 1 0-4 0 2 2 0 0 0 4 0"
})));
export default SvgAvatar;